import validate from "validate.js";
import pick from "lodash.pick";
import { INPUT_NAMES } from "../utils/config";

const allowEmpty = false;

validate.validators.uuid = function(value, options) {
	if (!value || value === "") {
		return null;
	}
	const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	if (!uuidRegex.test(value)) {
		return options.message || "validation.uuidFormat";
	}
};

const constraints = {
	[INPUT_NAMES.email]: {
		email: {
			message: "validation.email",
		},
	},
	[INPUT_NAMES.firstName]: {
		presence: {
			allowEmpty,
			message: "validation.firstName",
		},
	},
	[INPUT_NAMES.lastName]: {
		presence: {
			allowEmpty,
			message: "validation.lastName",
		},
	},
	[INPUT_NAMES.name]: {
		presence: {
			allowEmpty,
			message: "validation.name",
		},
	},
	[INPUT_NAMES.phoneNumber]: {
		presence: {
			allowEmpty,
			message: "validation.phone",
		},
	},
	[INPUT_NAMES.company]: {
		presence: {
			allowEmpty,
			message: "validation.company",
		},
	},
	[INPUT_NAMES.recaptcha]: {
		presence: {
			allowEmpty,
			message: "validation.recaptcha",
		},
	},
	[INPUT_NAMES.tenantId]: {
		uuid: {},
	},
	[INPUT_NAMES.tenantAdminId]: {
		uuid: {},
	},
};

// removing the parens creates an ambiguous arrow error
// eslint-disable-next-line no-extra-parens
export const isValid = errObj => (errObj ? false : null);

export default inputs => {
	const filteredConstraints = pick(constraints, Object.keys(inputs));
	return validate(inputs, filteredConstraints, { fullMessages: false });
};
